module.exports = __webpack_public_path__ + "img/mask-241903.fc6aac66.svg";